<template>
  <!--企业注册 审核中 -->
  <div class="login-container flex-b-r">
    <div class="login-body">
      <div class="title">
        <p style="cursor: pointer" @click="$router.push('/login')">
          返回登录页
        </p>
      </div>
      <!-- 表单区 -->
      <div class="firmSign-Body">
        <!-- 暂无数据 -->
        <div class="None-data">
          <div class="None-data-figure"></div>
          <div class="None-data-Tips">
            <p>已提交审核</p>
          </div>
        </div>
      </div>
    </div>
    <div class="BaseMap"></div>
  </div>
</template>

<script>
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {};
  },
  watch: {},

  // 组件初始化
  created() {},
  // 组件实例挂载完毕
  mounted() {},
  //销毁事件
  destroyed() {},
  // 组件方法
  methods: {},
};
</script>

<style scoped lang="less">
// 主体内容
.login-container {
  min-width: 1230px !important;
  height: 100%;
  min-height: 740px;
  display: flex;
  flex-direction: column;
  background: #0054cc;
  background-image: linear-gradient(
    90deg,
    rgba(97, 144, 232, 0.5) 0%,
    rgba(167, 191, 232, 0.5) 99%
  );
  // 中心白色区域
  .login-body {
    min-width: 1200px;
    min-height: 520px !important;
    font-size: 16px;
    margin: auto;
    background-color: #ffffff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    .title {
      width: 100%;
      height: 40px;
      line-height: 40px;
      margin-top: 30px;
      font-family: FZLTCHJW--GB1-0;
      font-size: 18px;
      color: #409eff ;
      font-weight: 600;
      text-align: center;
      position: relative;
      p {
        width: 120px;
        height: 40px;
        background: #409eff ;
        border-radius: 5px;
        position: absolute;
        right: 30px;
        top: 0;
        font-size: 16px;
        color: #ffffff;
        font-weight: 400;
      }
    }
    // 企业注册表单主体
    .firmSign-Body {
      min-width: 1150px;
      min-height: 300px;
      margin-top: 25px;
      display: flex;
      .None-data {
        min-width: 120px;
        min-height: 175px;
        margin: auto;
        // 暂无数据时 显示的图片
        .None-data-figure {
          min-width: 120px;
          min-height: 120px;
          background-image: url("../../assets/imgs/zanwushuju@3x.svg");
          background-size: 100% 100%;
        }
        // 暂无数据提示
        .None-data-Tips {
          width: 110px;
          height: 28px;
          margin-top: 20px;
          p {
            width: 110px;
            height: 14px;
            line-height: 14px;
            text-align: center;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #999999;
            font-weight: 400;
          }
        }
      }
    }
  }
  // 底图
  .BaseMap {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/imgs/img/beijinglou@2x.png");
    background-size: 100% 100%;
    position: absolute;
    bottom: 0;
  }
}
</style>
